import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "StripePublicKey", -1)
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "StripeSecretKey", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue.stripePublicKey) = $event))
      }, null, 512), [
        [_vModelText, _ctx.localValue.stripePublicKey]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localValue.stripeSecretKey) = $event))
      }, null, 512), [
        [_vModelText, _ctx.localValue.stripeSecretKey]
      ])
    ])
  ]))
}